import classNames from 'classnames';
import { parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/dates-range.module.scss';

const propTypes = {
    className: PropTypes.string,
    startAt: PropTypes.string,
    endAt: PropTypes.string,
    withoutPrefix: PropTypes.bool,
    withYear: PropTypes.bool,
};

const defaultProps = {
    className: null,
    startAt: null,
    endAt: null,
    withoutPrefix: false,
    withYear: false,
};

function DatesRange({ className, startAt, endAt, withoutPrefix, withYear }) {
    const startDate = useMemo(() => (startAt !== null ? parseISO(startAt) : null), [startAt]);
    const endDate = useMemo(() => (endAt !== null ? parseISO(endAt) : null), [endAt]);
    const isSameMonth = useMemo(
        () => startDate !== null && endDate !== null && startDate.getMonth() === endDate.getMonth(),
        [startDate, endDate],
    );

    // const startDateDay = useMemo( () => startDate !== null ? startDate.getDay() : null, [startDate]);
    // const endDateDay = useMemo( () => endDate !== null ? endDate.getDay() : null, [endDate]);

    const containerClassName = classNames([styles.container, { [className]: className !== null }]);

    if (startDate !== null && endDate === null) {
        return (
            <div className={containerClassName}>
                {withoutPrefix ? (
                    <FormattedDate value={startDate} month="long" day="numeric" />
                ) : (
                    <FormattedMessage
                        defaultMessage="From {start_date}"
                        description="Date range label"
                        values={{
                            start_date: (
                                <FormattedDate value={startDate} month="long" day="numeric" />
                            ),
                        }}
                    />
                )}
                {withYear ? (
                    <>
                        {' '}
                        <FormattedDate value={endDate} year="numeric" />
                    </>
                ) : null}
            </div>
        );
    }

    if (startDate === null && endDate !== null) {
        return (
            <div className={containerClassName}>
                {withoutPrefix ? (
                    <FormattedDate value={startDate} month="long" day="numeric" />
                ) : (
                    <FormattedMessage
                        defaultMessage="Until {end_date}"
                        description="Dates Range (end date only)"
                        values={{
                            end_date: <FormattedDate value={endDate} month="long" day="numeric" />,
                        }}
                    />
                )}
                {withYear ? (
                    <>
                        {' '}
                        <FormattedDate value={endDate} year="numeric" />
                    </>
                ) : null}
            </div>
        );
    }

    if (isSameMonth) {
        return (
            <div className={containerClassName}>
                {withoutPrefix ? (
                    <FormattedMessage
                        defaultMessage="{month} {start_day} to {end_day}"
                        description="Dates Range (same month)"
                        values={{
                            month: <FormattedDate value={startDate} month="long" />,
                            start_day: <FormattedDate value={startDate} day="numeric" />,
                            end_day: <FormattedDate value={endDate} day="numeric" />,
                        }}
                    />
                ) : (
                    <FormattedMessage
                        defaultMessage="From {month} {start_day} to {end_day}"
                        description="Dates Range (same month)"
                        values={{
                            month: <FormattedDate value={startDate} month="long" />,
                            start_day: <FormattedDate value={startDate} day="numeric" />,
                            end_day: <FormattedDate value={endDate} day="numeric" />,
                        }}
                    />
                )}
                {withYear ? (
                    <>
                        {' '}
                        <FormattedDate value={endDate} year="numeric" />
                    </>
                ) : null}
            </div>
        );
    }

    return (
        <div className={containerClassName}>
            {withoutPrefix ? (
                <FormattedMessage
                    defaultMessage="{start_date} to {end_date}"
                    description="Dates Range (different month)"
                    values={{
                        start_date: <FormattedDate value={startDate} month="long" day="numeric" />,
                        end_date: <FormattedDate value={endDate} month="long" day="numeric" />,
                    }}
                />
            ) : (
                <FormattedMessage
                    defaultMessage="From {start_date} to {end_date}"
                    description="Dates Range (different month)"
                    values={{
                        start_date: <FormattedDate value={startDate} month="long" day="numeric" />,
                        end_date: <FormattedDate value={endDate} month="long" day="numeric" />,
                    }}
                />
            )}
            {withYear ? (
                <>
                    {' '}
                    <FormattedDate value={endDate} year="numeric" />
                </>
            ) : null}
        </div>
    );
}

DatesRange.propTypes = propTypes;
DatesRange.defaultProps = defaultProps;

export default DatesRange;
